import Api from '../api';

// We have to interface with a legacy (cordova) component, so loosen
// up the type checking on the global object. (declare a reference to it as type 'any')
const g:any = global;

export default class FirebaseCloudMessagingNative {
  static instance : FirebaseCloudMessagingNative;
  private token : string = '';
  private associationDesired : boolean = false;
  static getInstance() { return this.instance ? this.instance : this.instance = new this() }
  private constructor() {
    // Is the FCM plugin present?
    if (g.FCMPlugin === undefined) return;

    // Prepare to handle token information
    g.FCMPlugin.onTokenRefresh(this.setToken.bind(this));

    // Prepare to handle message notifications
    g.FCMPlugin.onNotification(this.onNotification);

    // Request a token from firebase for this device.
    g.FCMPlugin.getToken(this.setToken.bind(this));
  }

  setToken(token : string) {
    this.token=token;
    if (this.associationDesired) this.associateToken();
  }

  associateToken() {
    this.associationDesired = true;
    // Associate the token with the currently logged in user.
    if (this.token==='') return;
    let api = new Api(g.gqlClient());
    api.addFirebaseToken(this.token);  
  }

  disassociateToken() {
    this.associationDesired = false;
    // Disassociate the token from the currently logged in user.
    if (this.token==='') return;
    let api = new Api(g.gqlClient());
    api.delFirebaseToken(this.token);

    // Clear any waiting notifications
    if (g.FCMPlugin !== undefined) g.FCMPlugin.clearAllNotifications();
  }

  // Notifications are recieved while the app is running, or when a user
  // clicks their notification tray.
  onNotification(notification : any) {
    /* eslint no-console: off */
    console.log({notification});
  }
}